import { render, staticRenderFns } from "./ProuniHeader.vue?vue&type=template&id=5dfc70c0&scoped=true&"
import script from "./ProuniHeader.vue?vue&type=script&lang=ts&"
export * from "./ProuniHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ProuniHeader.vue?vue&type=style&index=0&id=5dfc70c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfc70c0",
  null
  
)

export default component.exports